// Corta la captura en fragmentos de ~25s para enviarlos a transcribir (Bloque C2, paso 4).
// Cada fragmento es su PROPIA grabación completa (una MediaRecorder nueva por fragmento, no
// timeslice sobre una sola grabación continua): con timeslice, los eventos intermedios de
// webm/opus no son un archivo decodificable por sí solo (solo el primero trae el encabezado);
// reiniciar la grabación cada ~25s sí produce un webm válido y completo cada vez.

const MIME_CANDIDATES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/ogg;codecs=opus",
];

export const pickAudioMimeType = (): string =>
  MIME_CANDIDATES.find((t) => MediaRecorder.isTypeSupported?.(t)) ?? "";

export type ChunkHandler = (blob: Blob, durationSeconds: number) => void;

/** Arranca el corte en fragmentos. Devuelve una función para detenerlo (nunca deja una
 * grabación viva: `stop()` en la última no dispara otra). */
export const startChunking = (
  stream: MediaStream,
  onChunk: ChunkHandler,
  segmentMs = 25_000,
): (() => void) => {
  let stopped = false;
  let recorder: MediaRecorder | null = null;
  let timer: ReturnType<typeof globalThis.setTimeout> | undefined;

  const recordOne = () => {
    if (stopped) return;
    const mimeType = pickAudioMimeType();
    recorder = mimeType
      ? new MediaRecorder(stream, { mimeType })
      : new MediaRecorder(stream);
    const startedAt = Date.now();
    recorder.ondataavailable = (e: BlobEvent) => {
      if (e.data.size > 0) onChunk(e.data, (Date.now() - startedAt) / 1000);
    };
    recorder.onstop = () => {
      if (!stopped) recordOne();
    };
    recorder.start();
    timer = globalThis.setTimeout(() => recorder?.stop(), segmentMs);
  };
  recordOne();

  return () => {
    stopped = true;
    clearTimeout(timer);
    recorder?.stop();
  };
};
